import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

export type ChangePasswordPayload = {
  old_password: string;
  new_password: string;
  new_password_confirm: string;
};

export const useChangePasswordMutation = () => {
  const { t } = useTranslation();

  return useTypedMutation<ChangePasswordPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/password/change", payload, ENV.authBaseURL);
    },
    onSuccess: () => toast.success(t("v8_your_password_was_successfully_reset", "Your password was successfully reset!"))
  });
};
